<template>
  <div class="row">
    <bread-crumb>
      <BreadCrumbItem
        v-for="(route,index) in items"
        :key="route.name"
        style="display:inline-block"
      >
        <router-link
          :to="{ name: route.link }"
          v-if="index < items.length - 1"
          class="breadcrumb-link"
        >
          {{ route.name }}
        </router-link>
        <span v-else class="breadcrumb-current">{{ route.name }}</span>
      </BreadCrumbItem>
    </bread-crumb>
  </div>
</template>

<script>
import BreadCrumb from './Breadcrumb';
import BreadCrumbItem from './BreadcrumbItem';

export default {
  name: 'route-breadcrumb',
  components: {
    BreadCrumb,
    BreadCrumbItem
  },
  props:{
    items:{
      required:true
    }
  },
  methods: {
    getBreadName(route) {
      return route.name;
    }
  }
};
</script>

<style scoped></style>
